import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useContext, useEffect, useState} from "react";
import AuthContext from "../../context/AuthContext";
import IceButton from "../../components/Button";
import TextField from "@mui/material/TextField";


export default function DialogParkSrcField(props: any) {
    let {user, authTokens, serverIP, userPermissions} = useContext(AuthContext)
    let {parkObj, setParkObj, projUID, refreshFunc} = props
    // console.log(parkObj)

    let mapStatus = parkObj?.srcFieldObj?.mapStatus
    // console.log('--->', mapStatus)

    function handlePark() {

        fetch(`${serverIP}/parksrcfield/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify({
                user: user.username,
                projUID: projUID,
                srcFieldUID: parkObj.srcFieldObj?.fieldUID,
                comment: parkComment,
                mapStatus: mapStatus
            }),
        }).then(res => res.json())
            .then((data) => {
                // if (data.code === 204) {
                setActionStatus(data.code)
                // })
                // console.log('Success')
                // }
                // console.log(data)
            })

        setParkObj((prev: any) => {
            return {...prev, isOpen: false, srcFieldObj: {}}
        }) // a dialog must be closed anyway after Save is clicked

        setParkComment("")
    }

    const [actionStatus, setActionStatus] = useState(0)

    useEffect(() => {
        if (actionStatus > 0) {
            refreshFunc()
            setActionStatus(0)
        }
    }, [actionStatus])


    const [parkComment, setParkComment] = useState<any>("")

    function handleParkComment(event: any) {
        setParkComment(event.target.value)
        // console.log(event.target.value)
    }

    let dialContentRes = undefined
    if (mapStatus == 'mapped') {
        dialContentRes = (
            <>
                <DialogTitle sx={{paddingLeft: "0 !important"}}>Parking source field</DialogTitle>
                <DialogContentText style={{fontSize: '0.9rem'}}>
                    This field <strong>{parkObj.srcFieldObj.fieldName}</strong> is mapped ! <br/>
                    Mapped fields which take part in mappings can't be parked. <br/><br/>
                    Please remove existing mappings for this field and then proceed with parking.
                </DialogContentText>
            </>
        )
    } else if (mapStatus == 'not mapped') {
        dialContentRes = (
            <>
                <DialogTitle sx={{paddingLeft: "0 !important"}}>Parking source field</DialogTitle>
                <DialogContentText style={{fontSize: '0.9rem'}}>
                    You are about to park the source
                    field <strong>{parkObj.srcFieldObj.fieldName} (ID: {parkObj.srcFieldObj.fieldID}</strong>)<br/>
                    <br/>
                    You may specify the reason for parking the field (optionally):
                </DialogContentText>

                {/* a field can only be parked if it's "not mapped". If it's "parked" or "mapped" then it CANNOT be parked.  */}
                <TextField
                    sx={{backgroundColor: "#f2f2f2", borderRadius: "5px", border: "none !important"}}
                    value={parkComment}
                    autoFocus
                    margin="dense"
                    id="park-comment"
                    // label="type here:"
                    type="text"
                    fullWidth
                    variant="standard"
                    multiline
                    minRows={2}
                    maxRows={4}
                    onChange={(event: any) => handleParkComment(event)}
                />
            </>
        )
    } else if (mapStatus == 'parked') {
        dialContentRes = (
            <>
                <DialogTitle sx={{paddingLeft: "0 !important", paddingTop: "0 !important"}}>Unparking source field</DialogTitle>
                <DialogContentText style={{fontSize: '0.9rem'}}>
                    You are about to unpark the source
                    field <strong>{parkObj.srcFieldObj.fieldName} (ID: {parkObj.srcFieldObj.fieldID}</strong>)<br/>
                    <br/>
                    {parkObj.srcFieldObj?.parkData && <>
                        <strong>Parking data:</strong>
                        <div className="park-data">
                            <div className="cell">Parked by:</div>
                            <div className="cell">{parkObj.srcFieldObj?.parkData.parkedBy}</div>
                            <div className="cell">Date of park:</div>
                            <div className="cell">{parkObj.srcFieldObj?.parkData.date}</div>
                            {parkObj.srcFieldObj.parkData?.comment && <>
                                <div className="cell">Parking comment:</div>
                                <div className="cell">{parkObj.srcFieldObj.parkData?.comment}</div>
                            </>}
                        </div>
                    </>}

                    Please confirm the unparking action below.
                </DialogContentText>
            </>
        )
    }
    // console.log(dialContentRes)

    return (

        <Dialog
            open={parkObj.isOpen}
            onClose={() => setParkObj((prev: any) => {
                return {...prev, isOpen: false, srcFieldObj: {} }})}
        >

            <DialogContent>{dialContentRes}</DialogContent>

            <DialogActions sx={{marginBottom: "10px", marginRight: "10px !important"}}>

                {mapStatus !== 'mapped' && <IceButton
                    type={userPermissions.canEdit ? "primary" : "secondary"}
                    text={mapStatus == 'parked' ?  "Unpark" : "Park"}
                    onclick={userPermissions.canEdit ? handlePark : undefined}/>
                }

                <IceButton
                    type="delete"
                    text={mapStatus == 'mapped' ? "Close" : "Cancel"}
                    onclick={() => setParkObj((prev: any) => {
                        return {...prev, isOpen: false, srcFieldObj: {} } })}
                />
            </DialogActions>

        </Dialog>
    )
}
